<script lang="ts">
  interface Props {
    list?: CommonList[];
    active?: string;
    onclick?: (nav: CommonList) => void;
  }

  let { list = [], active = '', onclick }: Props = $props();

  const onClickNav = (nav: CommonList) => {
    onclick?.(nav);
  };
</script>

<div class="comp-main-nav">
  {#each list as nav}
    <button
      class="nav-i"
      data-cy={nav.id}
      class:active={active == nav.id}
      onclick={(e) => { e.preventDefault(); e.stopPropagation(); onClickNav(nav); }}>{nav.label}</button
    >
  {/each}
</div>

<style>
  .comp-main-nav {
    display: flex;
    align-items: center;
  }
  .nav-i {
    background-color: transparent;
    border: 0;
    outline: 0;
    font-size: 14px;
    color: var(--text-color-grey);
    font-weight: 600;
  }
  .nav-i:hover {
    color: var(--text-color-grey-dark);
  }
  .nav-i.active {
    color: var(--text-color-black);
  }
  .nav-i:not(:last-child) {
    margin-right: 36px;
  }
</style>
